/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NalClientNames } from '../models/NalClientNames';
import type { NalEvaluation } from '../models/NalEvaluation';
import type { NalEvaluations } from '../models/NalEvaluations';
import type { NalEvaluationUpdateRequest } from '../models/NalEvaluationUpdateRequest';
import type { NalManagerEvaluations } from '../models/NalManagerEvaluations';
import type { NalPeriod } from '../models/NalPeriod';
import type { NalPeriodCloseByCsmRequest } from '../models/NalPeriodCloseByCsmRequest';
import type { NalPeriodOverview } from '../models/NalPeriodOverview';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ControllingNalService {
    /**
     * list distinct client names for a nal period
     * @param tenantId tenant_id
     * @param periodId period in YYYY-RUN format
     * @param constructionSiteManagerIdsArray employee uuids, or "unknown" for evaluations without assignment
     * @returns NalClientNames returns the distinct, sorted client names of the period
     * @throws ApiError
     */
    public static listNalClientNames(
        tenantId: string,
        periodId: string,
        constructionSiteManagerIdsArray?: Array<string>,
    ): CancelablePromise<NalClientNames> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/controlling/nal_periods/{period_id}/client_names',
            path: {
                'tenant_id': tenantId,
                'period_id': periodId,
            },
            query: {
                'construction_site_manager_ids[]': constructionSiteManagerIdsArray,
            },
        });
    }
    /**
     * list nal evaluations by period
     * @param tenantId tenant_id
     * @param periodId period in YYYY-RUN format
     * @param constructionSiteManagerIdsArray employee uuids, or "unknown" for evaluations without assignment
     * @param clientNamesArray
     * @param search matches construction site number, description, or client name
     * @returns NalEvaluations empty list
     * @throws ApiError
     */
    public static listNalEvaluations(
        tenantId: string,
        periodId: string,
        constructionSiteManagerIdsArray?: Array<string>,
        clientNamesArray?: Array<string>,
        search?: string,
    ): CancelablePromise<NalEvaluations> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/controlling/nal_periods/{period_id}/nal_evaluations',
            path: {
                'tenant_id': tenantId,
                'period_id': periodId,
            },
            query: {
                'construction_site_manager_ids[]': constructionSiteManagerIdsArray,
                'client_names[]': clientNamesArray,
                'search': search,
            },
            errors: {
                403: `forbidden when employee lacks ability`,
                404: `period not found`,
            },
        });
    }
    /**
     * update nal evaluation
     * @param tenantId tenant_id
     * @param periodId period in YYYY-RUN format
     * @param id nal_evaluation id
     * @param requestBody
     * @returns NalEvaluation evaluation updated
     * @throws ApiError
     */
    public static updateNalEvaluation(
        tenantId: string,
        periodId: string,
        id: string,
        requestBody?: NalEvaluationUpdateRequest,
    ): CancelablePromise<NalEvaluation> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/tenants/{tenant_id}/controlling/nal_periods/{period_id}/nal_evaluations/{id}',
            path: {
                'tenant_id': tenantId,
                'period_id': periodId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `forbidden when employee lacks ability`,
                422: `unprocessable: validation failed or period has been released`,
            },
        });
    }
    /**
     * list nal manager evaluations grouped by csm
     * @param tenantId tenant_id
     * @param periodId period in YYYY-RUN format
     * @param constructionSiteManagerIdsArray employee uuids, or "unknown" for evaluations without assignment
     * @param clientNamesArray
     * @param search matches construction site number, description, or client name
     * @returns NalManagerEvaluations returns empty csm_groups when no evaluations exist
     * @throws ApiError
     */
    public static listNalManagerEvaluations(
        tenantId: string,
        periodId: string,
        constructionSiteManagerIdsArray?: Array<string>,
        clientNamesArray?: Array<string>,
        search?: string,
    ): CancelablePromise<NalManagerEvaluations> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/controlling/nal_periods/{period_id}/nal_manager_evaluations',
            path: {
                'tenant_id': tenantId,
                'period_id': periodId,
            },
            query: {
                'construction_site_manager_ids[]': constructionSiteManagerIdsArray,
                'client_names[]': clientNamesArray,
                'search': search,
            },
            errors: {
                403: `forbidden when employee lacks ability`,
            },
        });
    }
    /**
     * seed a NAL period chain (staging/development only)
     * @param tenantId tenant_id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static createNalPeriodSeed(
        tenantId: string,
        requestBody?: {
            period: string;
        },
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tenants/{tenant_id}/controlling/nal_period_seed',
            path: {
                'tenant_id': tenantId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `forbidden when employee lacks ability`,
            },
        });
    }
    /**
     * wipe all NAL data (staging/development only)
     * @param tenantId tenant_id
     * @returns void
     * @throws ApiError
     */
    public static destroyNalPeriodSeed(
        tenantId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/tenants/{tenant_id}/controlling/nal_period_seed',
            path: {
                'tenant_id': tenantId,
            },
            errors: {
                403: `forbidden when employee lacks ability`,
            },
        });
    }
    /**
     * list nal periods
     * @param tenantId tenant_id
     * @returns any empty list
     * @throws ApiError
     */
    public static listNalPeriods(
        tenantId: string,
    ): CancelablePromise<{
        nal_periods?: Array<NalPeriod>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/controlling/nal_periods',
            path: {
                'tenant_id': tenantId,
            },
            errors: {
                403: `forbidden when employee lacks ability`,
            },
        });
    }
    /**
     * create nal period
     * @param tenantId tenant_id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static createNalPeriod(
        tenantId: string,
        requestBody?: {
            year: number;
            run: number;
            entry_deadline?: string;
            release_deadline?: string;
        },
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tenants/{tenant_id}/controlling/nal_periods',
            path: {
                'tenant_id': tenantId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `forbidden when employee lacks ability`,
                422: `unprocessable entity when the requested period is not openable`,
            },
        });
    }
    /**
     * show nal period
     * @param tenantId tenant_id
     * @param period period in YYYY-RUN format
     * @returns NalPeriod period shown
     * @throws ApiError
     */
    public static showNalPeriod(
        tenantId: string,
        period: string,
    ): CancelablePromise<NalPeriod> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/controlling/nal_periods/{period}',
            path: {
                'tenant_id': tenantId,
                'period': period,
            },
            errors: {
                403: `forbidden when employee lacks ability`,
                404: `not found`,
            },
        });
    }
    /**
     * close nal period for csm
     * @param tenantId tenant_id
     * @param periodId period in YYYY-RUN format
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static closeNalPeriodByCsm(
        tenantId: string,
        periodId: string,
        requestBody?: NalPeriodCloseByCsmRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/tenants/{tenant_id}/controlling/nal_periods/{period_id}/close_by_csm',
            path: {
                'tenant_id': tenantId,
                'period_id': periodId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `forbidden when closing for a csm without ability`,
                422: `unprocessable when the csm closed by manager has no completed evaluations`,
            },
        });
    }
    /**
     * release nal period as manager
     * @param tenantId tenant_id
     * @param periodId period in YYYY-RUN format
     * @returns void
     * @throws ApiError
     */
    public static releaseNalPeriodAsManager(
        tenantId: string,
        periodId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/tenants/{tenant_id}/controlling/nal_periods/{period_id}/release_by_manager',
            path: {
                'tenant_id': tenantId,
                'period_id': periodId,
            },
            errors: {
                403: `forbidden when employee lacks ability`,
                422: `unprocessable when csms have not closed or period already released`,
            },
        });
    }
    /**
     * release nal period as controlling
     * @param tenantId tenant_id
     * @param periodId period in YYYY-RUN format
     * @returns void
     * @throws ApiError
     */
    public static releaseNalPeriodAsControlling(
        tenantId: string,
        periodId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/tenants/{tenant_id}/controlling/nal_periods/{period_id}/release_by_controlling',
            path: {
                'tenant_id': tenantId,
                'period_id': periodId,
            },
            errors: {
                403: `forbidden when employee lacks ability`,
                422: `unprocessable when managing director has not released the period yet, or it is already released by controlling`,
            },
        });
    }
    /**
     * manually export nal period
     * @param tenantId tenant_id
     * @param periodId period in YYYY-RUN format
     * @returns void
     * @throws ApiError
     */
    public static exportNalPeriod(
        tenantId: string,
        periodId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tenants/{tenant_id}/controlling/nal_periods/{period_id}/export',
            path: {
                'tenant_id': tenantId,
                'period_id': periodId,
            },
            errors: {
                403: `forbidden when employee lacks ability`,
                422: `unprocessable when the period is not released by the manager yet`,
            },
        });
    }
    /**
     * revoke nal period controlling release
     * @param tenantId tenant_id
     * @param periodId period in YYYY-RUN format
     * @returns void
     * @throws ApiError
     */
    public static revokeNalPeriodControllingRelease(
        tenantId: string,
        periodId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/tenants/{tenant_id}/controlling/nal_periods/{period_id}/revoke_release_by_controlling',
            path: {
                'tenant_id': tenantId,
                'period_id': periodId,
            },
            errors: {
                403: `forbidden when employee lacks ability`,
                422: `unprocessable when the period is not released by controlling, or the next period has already been opened`,
            },
        });
    }
    /**
     * show nal period overview for all tenants
     * @param periodId period in YYYY-RUN format
     * @returns NalPeriodOverview overview shown
     * @throws ApiError
     */
    public static showNalPeriodOverview(
        periodId: string,
    ): CancelablePromise<NalPeriodOverview> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/controlling/nal_periods/{period_id}/overview',
            path: {
                'period_id': periodId,
            },
            errors: {
                403: `forbidden when employee lacks ability`,
            },
        });
    }
}
